<template>
    <div>
        <a-modal :title="title" :visible='sureVisible' :width="1200" @ok="handleOk" @cancel="handleCancel">
            <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
            </template>
            <div>
                <a-table ref="table" size="middle" bordered
                    :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)" 
                    :pagination="ipagination" :loading="loading" 
                    style="word-break: break-all;">
                    <span slot="action" slot-scope="text, record">
                    <a type="primary" @click="edit(record)">编辑</a>
                    <a-divider type="vertical" />
                    <a type="primary" @click="handleDelete(record)">删除</a>
                    </span>
                    <template slot="createTime" slot-scope="createTime">
                    <span>{{changetime(createTime)}}</span>
                    </template>
                
                </a-table>
                
            </div>
        </a-modal>
    </div>
</template>
<script>
// import { companyDetail } from '@/api/api'
import { campListMixins } from '../mixins/campListMixins'

export default { 
    name: 'campDetail',
    mixins: [campListMixins],
    data() {
      return { 
        title: '商品证照--商品列表',
        sureVisible:false,
        columns: [
          { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
          { title: '产品名称', dataIndex: 'materialName',width: 80, align: "center",},
          { title: '编码', dataIndex: 'code', width: 100, ellipsis: true, render: (text) => text || "--" },
          { title: '规格/型号', dataIndex: 'specificationModel',width: 120, render: (text) => text || "--"},
          { title: '单位', dataIndex: 'unit', width: 120, render: (text) => text || "--" },
        //   { title: '有效日期', dataIndex: 'expirationDate', width: 120 ,ellipsis: true, render: (text) => text || "--" },
        ],
        // dataSource: {
        //     productName: '2'
        // }
      }
    },
    mounted(){
    },
    methods: {
        initShow(e){
            console.log(e.result,'======================e===============')
            this.sureVisible = true
            this.dataSource = e.result

        },
        handleOk(){
            this.sureVisible = false
        },
        handleCancel(){
            this.sureVisible = false
        },
    }
}
</script>
<style lang="less" scoped>
    /deep/.ant-col {
        display: flex;
    }
    .basicTitle {
        display: block;
        font-size: 16x;
        margin: 0 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
    .lisenceTitle {
        display: block;
        font-size: 16x;
        margin: 30px 0 30px;
        padding-left: 10px;
        border-left: 4px solid #1890FF;
    }
</style>
